<template>
  <div class="top">
    <img src="./../assets/illustrations/Leaf.png" />
    <img src="./../assets/illustrations/Lightning.png" />
    <img src="./../assets/illustrations/Moon.png" />
    <img src="./../assets/illustrations/Moon.png" />
    <img src="./../assets/illustrations/Sunglasses.png" />
    <img src="./../assets/illustrations/Triangle.png" />
    <img src="./../assets/illustrations/Music.png" />
    <img src="./../assets/illustrations/Smile.png" />
    <img src="./../assets/illustrations/Ladder.png" />
    <img src="./../assets/illustrations/Music.png" />
    <img src="./../assets/illustrations/Mountain.png" />
    <img src="./../assets/illustrations/Lightning.png" />
    <img src="./../assets/illustrations/Moon.png" />
    <img src="./../assets/illustrations/Sunglasses.png" />
    <img src="./../assets/illustrations/Triangle.png" />
    <img src="./../assets/illustrations/Moon.png" />
    <img src="./../assets/illustrations/BarbieArm.png" />
    <img src="./../assets/illustrations/Mountain.png" />
    <img src="./../assets/illustrations/QLD.png" />
    <img src="./../assets/illustrations/Flamingo.png" />
    <img src="./../assets/illustrations/Mushroom.png" />
  </div>
</template>
<script lang="ts">
  export default {
    name: 'Top'
  }
</script>
<style type="text/css" scoped>
  
.top {
 width:100%;
 display:flex;
 justify-items:space-between;
 overflow:hidden
}
.top,
.top img {
 height:90px
}
.top img:nth-child(3n) {
 height:60px;
 vertical-align:bottom
}
.top img:nth-child(2n) {
 height:30px;
 vertical-align:top;
 margin-top:25px
}
.top img:nth-child(4n) {
 filter: hue-rotate(120deg);
}


.top img:nth-child(5n) {
 transform: scaleX(-1);
}
</style>